export default __webpack_public_path__ + "cc93558faa1e8e7421dd27632d3a0944.jpg";